import {
	StatCard,
	type StatCardProps
} from '@/features/marquee/components/stat-card'
import { cn } from '@/helpers/utils'

type CheckInStat = Omit<StatCardProps, 'className'>

// Column below the breakpoint, single row that fills the width above it — the
// tiles share the space equally (flex-1) and never wrap onto a second line.
const GRID_CLASS = 'flex flex-col gap-4 l:flex-row'

interface CheckInStatsProps {
	stats: CheckInStat[]
	className?: string
}

export function CheckInStats({ stats, className }: CheckInStatsProps) {
	return (
		<div className={cn(GRID_CLASS, className)}>
			{stats.map((stat) => (
				<StatCard
					className='l:min-w-0 l:flex-1'
					key={stat.label}
					{...stat}
				/>
			))}
		</div>
	)
}
